export default "__VITE_ASSET__CEohY$ui__"